import { useEffect, useState } from 'react';

import { get, getDatabase, ref, runTransaction } from 'firebase/database';

import app from 'gatsby-plugin-firebase-v9.0';

export const useFirebaseLikes = templateId => {
  const [likes, setLikes] = useState(0);

  /**
   * Get the total amount of like.
   */
  const getLikes = () => {
    const likesRef = ref(getDatabase(app), `templates/${templateId}/likes`);

    get(likesRef)
      .then(snapshot => {
        if (snapshot.exists()) {
          setLikes(snapshot.val());
        } else {
          setLikes(0);
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  useEffect(() => {
    getLikes();
  }, [templateId]);

  /**
   * Increments the amount of likes by 1.
   */
  const incrementLikes = () => {
    const likesRef = ref(getDatabase(app), `templates/${templateId}/likes`);

    runTransaction(likesRef, currentLikes => (currentLikes || 0) + 1)
      .then(transactionResult => {
        if (transactionResult.committed) {
          setLikes(transactionResult.snapshot.val());
        } else {
          console.error(transactionResult);
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  /**
   * Decrements the amount of likes by 1.
   */
  const decrementLikes = () => {
    const likesRef = ref(getDatabase(app), `templates/${templateId}/likes`);

    runTransaction(likesRef, currentLikes => (currentLikes || 0) - 1)
      .then(transactionResult => {
        if (transactionResult.committed) {
          setLikes(transactionResult.snapshot.val());
        } else {
          console.error(transactionResult);
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  return { likes, getLikes, incrementLikes, decrementLikes };
};
